import { QueryClient } from "@tanstack/react-query";

/*
 * QueryClient do painel (FE-0 CP-D — ADR 0026 §Estado / TanStack Query).
 *
 * Server-state SÓ aqui (regra dura do ADR): cache, revalidação e dedup do dado
 * de servidor. NÃO há hooks de dados de negócio nesta fase — só a infraestrutura
 * de cache. As queries de projeção/fila/`eu` entram em CPs futuros.
 *
 * Config conservadora:
 *  - `staleTime` de 30s: evita refetch agressivo em foco/montagem, sem segurar
 *    dado velho demais para um painel financeiro.
 *  - `retry: 1`: uma única retentativa. O ciclo de sessão (401/refresh) é do
 *    interceptor axios — Query NÃO deve re-tentar 401/403/404/503 às cegas; com
 *    1 retry o custo de um falso-negativo de rede é baixo e o ADR mantém o
 *    tratamento de erro tipado no HTTP client.
 *  - `refetchOnWindowFocus: false`: foco de janela não dispara refetch (dev e
 *    multi-aba ficariam ruidosos; revalidação explícita virá nas telas).
 */
export function criarQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
